export default "__VITE_ASSET__DGtcCI0H__"